/*
 * Copyright 2024, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";

interface DetailRowProps {
  label: string;
  value?: string | number | null;
}

const DetailRow: React.FC<DetailRowProps> = ({ label, value }) => {
  if (!value) return null;

  return (
    <div className="flex gap-2 mb-2">
      <span className="text-sm text-muted-foreground font-medium w-2/5 shrink-0">{label}</span>
      <span className="text-sm text-foreground">{value}</span>
    </div>
  );
};

export default DetailRow;
